var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10C13.6642 10 14 10.3358 14 10.75V13.25C14 13.6642 13.6642 14 13.25 14H2.75C2.33579 14 2 13.6642 2 13.25V10.75C2 10.3358 2.33579 10 2.75 10C3.16421 10 3.5 10.3358 3.5 10.75V12.5H12.5V10.75C12.5 10.3358 12.8358 10 13.25 10ZM7.64648 2.13672C7.84025 1.95451 8.15886 1.95439 8.35254 2.13672L11.8525 5.43164C11.9961 5.564 12.0399 5.76695 11.9619 5.94336C11.8838 6.11986 11.7021 6.23438 11.499 6.23438H9.49902V9.05859C9.49902 9.57928 9.05213 10 8.49902 10H7.49902C6.94605 9.99985 6.49902 9.57918 6.49902 9.05859V6.23438H4.49902C4.29608 6.23423 4.11208 6.11678 4.03711 5.94336C3.96211 5.7698 4.00274 5.56696 4.14648 5.43164L7.64648 2.13672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload16W);
export default __webpack_public_path__ + "static/media/Upload_16w.0bab096454f03bbde8913e0c091771ec.svg";
export { ForwardRef as ReactComponent };